import { v as ECustomerType } from './request.constants-deb285e0.js';

/**
 * Returns cookie value or undefined if no cookie.
 */
const getCookie = (name) => {
    const regexp = new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`);
    const matches = document.cookie.match(regexp);
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

const getUserSessionLoggedInValue = () => {
    return getCookie(ECustomerType.CLASSIFICATION1);
};

const createSlides = (items = {}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
  const galleryItems = [];
  const mainImage = {
    title: (_a = items.zoomPicturePreview) === null || _a === void 0 ? void 0 : _a.title,
    preview: (_b = items.zoomPicturePreview) === null || _b === void 0 ? void 0 : _b.url,
    src: ((_c = items.zoomPictureDesktop) === null || _c === void 0 ? void 0 : _c.url) || ((_d = items.zoomPicturePreview) === null || _d === void 0 ? void 0 : _d.url),
    mobile: ((_e = items.zoomPictureMobile) === null || _e === void 0 ? void 0 : _e.url) || ((_f = items.zoomPicturePreview) === null || _f === void 0 ? void 0 : _f.url),
    isHighResImageAvailable: !!((_g = items.zoomPictureDesktop) === null || _g === void 0 ? void 0 : _g.url),
    thumbnail: ((_h = items.zoomPictureThumbnail) === null || _h === void 0 ? void 0 : _h.url) || ((_j = items.zoomPicturePreview) === null || _j === void 0 ? void 0 : _j.url),
    type: 'img',
    isMainImage: true,
  };
  galleryItems.push(mainImage);
  const media3D = (_k = items.image360) === null || _k === void 0 ? void 0 : _k.image3dUrl;
  const media360 = (_l = items.image360) === null || _l === void 0 ? void 0 : _l.image360Url;
  if (media3D) {
    const media = {
      type: '3d',
      preview: 'https://www.se.com/fr/shop-static/assets/images/pdp-page/3d-icon.svg',
      title: '',
      src: media3D,
    };
    galleryItems.push(media);
  }
  if (media360) {
    const media = {
      type: '360',
      preview: 'https://www.se.com/fr/shop-static/assets/images/pdp-page/3d-icon.svg',
      title: '',
      src: media360,
    };
    galleryItems.push(media);
  }
  (_p = (_o = (_m = items.gallery) === null || _m === void 0 ? void 0 : _m.techIllustrationGroup) === null || _o === void 0 ? void 0 : _o.techIllustrations) === null || _p === void 0 ? void 0 : _p.forEach((illustration) => {
    const type = illustration.type === 'DIMENSION' ? 'dimension' : 'wiring-diagram';
    const image = {
      title: illustration.title,
      preview: `https://www.se.com/fr//shop-static/assets/images/pdp-page/${type}_icon.svg`,
      src: illustration.illustrationUrl,
      type,
    };
    galleryItems.push(image);
  });
  (_q = items.alternativeImages) === null || _q === void 0 ? void 0 : _q.forEach((image) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return galleryItems.push({
      title: (_a = image.preview) === null || _a === void 0 ? void 0 : _a.title,
      preview: (_b = image.preview) === null || _b === void 0 ? void 0 : _b.url,
      src: ((_c = image.desktop) === null || _c === void 0 ? void 0 : _c.url) || ((_d = image.preview) === null || _d === void 0 ? void 0 : _d.url),
      mobile: ((_e = image.mobile) === null || _e === void 0 ? void 0 : _e.url) || ((_f = image.preview) === null || _f === void 0 ? void 0 : _f.url),
      isHighResImageAvailable: !!((_g = image.desktop) === null || _g === void 0 ? void 0 : _g.url),
      thumbnail: ((_h = image.thumbnail) === null || _h === void 0 ? void 0 : _h.url) || ((_j = image.preview) === null || _j === void 0 ? void 0 : _j.url),
      type: 'img',
    });
  });
  (_s = (_r = items.gallery) === null || _r === void 0 ? void 0 : _r.videoGroups) === null || _s === void 0 ? void 0 : _s.forEach((group) => {
    var _a;
    (_a = group === null || group === void 0 ? void 0 : group.videoItems) === null || _a === void 0 ? void 0 : _a.forEach((videoItem) => {
      galleryItems.push(Object.assign(Object.assign({}, videoItem), { type: 'video', groupLabel: group === null || group === void 0 ? void 0 : group.groupLabel }));
    });
  });
  return galleryItems;
};
const IMAGE_TYPE = {
  IMAGE_TYPE_3D: '3d',
  IMAGE_TYPE_360: '360',
};

const MAX_PDP_WIDTH = 1200;
const ZOOM_AREA_WIDTH = 369;

export { IMAGE_TYPE as I, MAX_PDP_WIDTH as M, ZOOM_AREA_WIDTH as Z, createSlides as c, getUserSessionLoggedInValue as g };
